var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMissed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.74052 10.6094L6.38802 10.3852C7.49802 10.0769 8.64635 9.92106 9.79802 9.92106C11.2513 9.86816 12.7022 10.0788 14.0805 10.5427C14.8184 10.8191 15.5076 11.2112 16.1222 11.7044C16.7797 12.147 17.2885 12.7774 17.5822 13.5136C17.6689 13.8752 17.7114 14.2461 17.7072 14.6177C17.7151 14.7779 17.6912 14.9381 17.6369 15.089C17.5825 15.2399 17.4988 15.3786 17.3905 15.4969C17.1152 15.7037 16.7706 15.7959 16.4289 15.7544H14.3789C14.128 15.7697 13.8802 15.6926 13.6822 15.5377C13.5433 15.3815 13.4611 15.1831 13.4489 14.9744V14.1444C13.4562 13.9873 13.4271 13.8307 13.3639 13.6868C13.3008 13.5428 13.2052 13.4154 13.0847 13.3144C12.742 13.1421 12.3641 13.0514 11.9805 13.0494C11.4414 12.9661 10.9022 12.8827 10.3214 12.8494C9.31623 12.7798 8.30654 12.8784 7.33385 13.1411C7.18894 13.1614 7.05197 13.2197 6.93681 13.31C6.82165 13.4003 6.73237 13.5194 6.67802 13.6552C6.58976 13.9736 6.55872 14.3052 6.58635 14.6344C6.60621 14.7811 6.5959 14.9303 6.55606 15.0729C6.51623 15.2155 6.4477 15.3484 6.35469 15.4636C6.26196 15.552 6.1525 15.6211 6.03273 15.6668C5.91296 15.7124 5.78529 15.7337 5.65719 15.7294H3.92302C3.64657 15.745 3.36947 15.745 3.09302 15.7294C2.8538 15.701 2.63443 15.5824 2.47969 15.3977C2.33521 15.1463 2.27123 14.8566 2.29635 14.5677C2.28457 14.0984 2.37584 13.6322 2.56373 13.202C2.75163 12.7718 3.03158 12.388 3.38385 12.0777C4.06478 11.4375 4.86574 10.9385 5.74052 10.6094Z",
    stroke: "#CD3E3E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1538 4.23682L10.8846 7.50598C10.6502 7.73698 10.3342 7.86647 10.0051 7.86647C9.6759 7.86647 9.35995 7.73698 9.12547 7.50598L5.85547 4.23682",
    stroke: "#CD3E3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.85547 7.55584V4.23584H9.17547",
    stroke: "#CD3E3E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissed);
export default __webpack_public_path__ + "static/media/missed.995a7921858a02538a30e1886ff551d8.svg";
export { ForwardRef as ReactComponent };